import { http } from '@/core/api/';
import qs from 'qs';

const apiUrl = 'api/student';
const urlRegister = 'api/studentregistry/';
const urlSign = 'api/signature/';
const onlineRegistrationUrl = 'api/studentonlineregistration/';

export default {
  getBySie(sieId, webServiceSearchOnly = false) {
    let uri = `${apiUrl}/getstudent?studentSie=${sieId}`;

    if (webServiceSearchOnly) uri += `&searchMode=2`;

    return http.get(uri, {
      headers: {
        loading: false,
      },
    });
  },
  getAdvancedSearch(input) {
    let queryString = `firstName=${input.firstName}`;
    queryString += `&lastName=${input.lastName}`;
    queryString += `&birthDate=${input.birthDate}`;
    queryString += `&impediment=${input.primaryImpediment}`;
    queryString += `&schoolCode=${input.schoolCode}`;
    queryString += `&pageIndex=${input.pageIndex}`;
    queryString += `&pageSize=${input.pageSize}`;

    return http.get(`${apiUrl}/advancedstudentsearch?${queryString}`);
  },
  getImpediments() {
    return http.get('api/code/getprimaryimpediments');
  },
  canAccess(studentSie) {
    return http.get(`${apiUrl}/canaccess?studentSie=${studentSie}`);
  },
  sendReadAlert(studentSieId) {
    return http.get(`${apiUrl}/savealertlog/${studentSieId}`);
  },
  getTherapies(studentSie) {
    return http.get(`${apiUrl}/gettherapies?studentSie=${studentSie}`);
  },
  updateStudentContactInformation(updateContactInfo) {
    return http.put(
      `${apiUrl}/${updateContactInfo.regStudentId}/UpdateContactInformation`,
      updateContactInfo
    );
  },
  getTardinessLogs(regStudentId) {
    return http.get(`${apiUrl}/gettardinesslogs/?regStudentId=${regStudentId}`);
  },
  removeTransfer(locationTransferId) {
    return http.put(`${apiUrl}/deletetransfer/${locationTransferId}`);
  },
  downloadInventorySurveySummaryReport(academicYear) {
    http
      .get(
        `api/parentInventory/GetInventorySurveySummaryReport/${academicYear}`
      )
      .then((response) => {
        this.documentDownloadXlsReport(
          response.data.content,
          response.data.filename
        );
      });
  },
  documentDownloadXlsReport(content, filename) {
    let binaryString = window.atob(content);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    // Comentado hasta que el Telerik report genere el Excel correctamente
    //let blob = new Blob([bytes], { type: "application/xls" });
    let blob = new Blob([bytes], { type: 'application/pdf' });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  getstudentdetails(inData) {
    return http.get(
      `${urlRegister}getstudentdetails/${inData.regStudentId}/${inData.studentSieId}`
    );
  },
  saveStudentParentsInformation(inData) {
    return http.post(`${urlRegister}savestudentparentsinformation`, inData);
  },
  getHistorySign(studentSieId) {
    return http.get(`${urlSign}history/${studentSieId}`);
  },
  getDigitalSignatureFlag(studentSieId) {
    return http.get(`${urlSign}digitalsignatureflag/${studentSieId}`);
  },
  getOnlineRegistrationCatalog() {
    return http.get(`${onlineRegistrationUrl}catalog`);
  },
  getOnlineRegistration(registrationId) {
    return http.get(`${onlineRegistrationUrl}registration/${registrationId}`);
  },
  getOnlineRegistrationDocuments(registrationId) {
    return http.get(
      `${onlineRegistrationUrl}registrationdocuments/${registrationId}`
    );
  },
  changeCenter(registrationId, centerId) {
    return http.put(
      `${onlineRegistrationUrl}changecenter/${registrationId}/${centerId}`
    );
  },
  updateAddressInformation(payload) {
    return http.put(`${onlineRegistrationUrl}address`, payload);
  },
  async uploadPublicPortalDocument(params) {
    await http.post(
      `${onlineRegistrationUrl}uploadpublicportaldocument`,
      params,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
  validateReferralStudentFromPublicPortal({ regOnlineStudentId, eduespSie }) {
    return http.get(
      `${onlineRegistrationUrl}validatestudentsiefrompublicportal/${eduespSie}`
    );
  },
  relateReferralStudentFromPublicPortal(payload) {
    return http.post(
      `${onlineRegistrationUrl}relatestudentsiefrompublicportal`,
      payload
    );
  },

  validateCreationPreRegisterFromPublicPortal(publicPortalId) {
    return http.get(
      `${onlineRegistrationUrl}validatecreationpreregisterfrompublicportal/${publicPortalId}`
    );
  },
  createPreRegisterFromPublicPortal(publicPortalId) {
    return http.post(
      `${onlineRegistrationUrl}preregisterfrompublicportal/${publicPortalId}`
    );
  },
  saveOrSubmitOnlineRegRequest(payload) {
    return http.post(`${onlineRegistrationUrl}saveorsubmitrequest`, payload);
  },
  deleteRelatedStudentSie(registrationId) {
    return http.delete(
      `${onlineRegistrationUrl}deleterelatedstudentsie/${registrationId}`
    );
  },
  deleteReferral(registrationId) {
    return http.delete(
      `${onlineRegistrationUrl}deletereferral/${registrationId}`
    );
  },
  saveComment(payload) {
    return http.post(`${apiUrl}/savecomment`, payload);
  },
  revertEvaluationDiscussion(payload) {
    return http.post(`${apiUrl}/revertevaluationdiscussion`, payload);
  },
  revertSchoolDiscussion(payload) {
    return http.post(`${apiUrl}/revertschooldiscussion`, payload);
  },
  storeComment(payload) {
    return http.post(`${apiUrl}/storecomment`, payload);
  },
  getAllStudentImpediments(studentSieId) {
    return http.get(`${apiUrl}/allstudentimpediments/${studentSieId}`);
  },
  getDocumentAttachments(params) {
    const { studentSieId, includeDocumentTypeIds } = params;
    return http.get(`${apiUrl}/attachments/${studentSieId}`, {
      params: { includeDocumentTypeIds },
      paramsSerializer: (params) => qs.stringify(params),
    });
  },
  uploadDocument(payload) {
    return http.post(`${apiUrl}/uploaddocument`, payload);
  },
  getConductalPlanReadonlyDocument(peiId) {
    return http.get(`${apiUrl}/conductalplanreadonlydocument/${peiId}`);
  },
};
